const COUNTRY_COORDS = {
  Afeganistão: [33.93911, 67.709953],
  'África do Sul': [-30.559482, 22.937506],
  Albânia: [41.153332, 20.168331],
  Alemanha: [51.165691, 10.451526],
  Andorra: [42.546245, 1.601554],
  Angola: [-11.202692, 17.873887],
  'Antígua e Barbuda': [17.060816, -61.796428],
  'Arábia Saudita': [23.885942, 45.079162],
  Argélia: [28.033886, 1.659626],
  Argentina: [-38.416097, -63.616672],
  Armênia: [40.069099, 45.038189],
  Austrália: [-25.274398, 133.775136],
  Áustria: [47.516231, 14.550072],
  Azerbaijão: [40.143105, 47.576927],
  Bahamas: [25.03428, -77.39628],
  Bangladesh: [23.684994, 90.356331],
  Barbados: [13.193887, -59.543198],
  Barein: [25.930414, 50.637772],
  Belarus: [53.709807, 27.953389],
  Bélgica: [50.503887, 4.469936],
  Belize: [17.189877, -88.49765],
  Benin: [9.30769, 2.315834],
  Bolívia: [-16.290154, -63.588653],
  'Bósnia e Herzegovina': [43.915886, 17.679076],
  Botsuana: [-22.328474, 24.684866],
  Brasil: [-14.235004, -51.92528],
  Brunei: [4.535277, 114.727669],
  Bulgária: [42.733883, 25.48583],
  'Burkina Faso': [12.238333, -1.561593],
  Burundi: [-3.373056, 29.918886],
  Butão: [27.514162, 90.433601],
  'Cabo Verde': [16.002082, -24.013197],
  Camarões: [7.369722, 12.354722],
  Camboja: [12.565679, 104.990963],
  Canadá: [56.130366, -106.346771],
  Catar: [25.354826, 51.183884],
  Cazaquistão: [48.019573, 66.923684],
  Chade: [15.454166, 18.732207],
  Chile: [-35.675147, -71.542969],
  China: [35.86166, 104.195397],
  Chipre: [35.126413, 33.429859],
  Colômbia: [4.570868, -74.297333],
  Comores: [-11.875001, 43.872219],
  Congo: [-0.228021, 15.827659],
  'Costa do Marfim': [7.539989, -5.54708],
  'Costa Rica': [9.748917, -83.753428],
  Croácia: [45.1, 15.2],
  Cuba: [21.521757, -77.781167],
  Dinamarca: [56.26392, 9.501785],
  Djibouti: [11.825138, 42.590275],
  Dominica: [15.414999, -61.370976],
  Egito: [26.820553, 30.802498],
  'El Salvador': [13.794185, -88.89653],
  'Emirados Árabes Unidos': [23.424076, 53.847818],
  Equador: [-1.831239, -78.183406],
  Eritréia: [15.179384, 39.782334],
  Eslováquia: [48.669026, 19.699024],
  Eslovênia: [46.151241, 14.995463],
  Espanha: [40.463667, -3.74922],
  'Estados Unidos da América': [37.09024, -95.712891],
  Estônia: [58.595272, 25.013607],
  Eswatini: [-26.522503, 31.465866],
  Etiópia: [9.145, 40.489673],
  Fiji: [-16.578193, 179.414413],
  Filipinas: [12.879721, 121.774017],
  Finlândia: [61.92411, 25.748151],
  França: [46.603354, 1.888334],
  Gabão: [-0.803689, 11.609444],
  Gâmbia: [13.443182, -15.310139],
  Gana: [7.946527, -1.023194],
  Geórgia: [42.315407, 43.356892],
  Granada: [12.262776, -61.604171],
  Grécia: [39.074208, 21.824312],
  Guatemala: [15.783471, -90.230759],
  Guiana: [4.860416, -58.93018],
  Guiné: [9.945587, -9.696645],
  'Guiné Equatorial': [1.650801, 10.267895],
  'Guiné-Bissau': [11.803749, -15.180413],
  Haiti: [18.971187, -72.285215],
  Holanda: [52.132633, 5.291266],
  Honduras: [15.199999, -86.241905],
  Hungria: [47.162494, 19.503304],
  Iêmen: [15.552727, 48.516388],
  'Ilhas Marshall': [7.131474, 171.184478],
  'Ilhas Salomão': [-9.64571, 160.156194],
  Índia: [20.593684, 78.96288],
  Indonésia: [-0.789275, 113.921327],
  Irã: [32.427908, 53.688046],
  Iraque: [33.223191, 43.679291],
  Irlanda: [53.41291, -8.24389],
  Islândia: [64.963051, -19.020835],
  Israel: [31.046051, 34.851612],
  Itália: [41.87194, 12.56738],
  Jamaica: [18.109581, -77.297508],
  Japão: [36.204824, 138.252924],
  Jordânia: [30.585164, 36.238414],
  Kiribati: [-3.370417, -168.734039],
  Kuwait: [29.31166, 47.481766],
  Laos: [19.85627, 102.495496],
  Lesoto: [-29.609988, 28.233608],
  Letônia: [56.879635, 24.603189],
  Líbano: [33.854721, 35.862285],
  Libéria: [6.428055, -9.429499],
  Líbia: [26.3351, 17.228331],
  Liechtenstein: [47.166, 9.555373],
  Lituânia: [55.169438, 23.881275],
  Luxemburgo: [49.815273, 6.129583],
  'Macedônia do Norte': [41.608635, 21.745275],
  Madagáscar: [-18.766947, 46.869107],
  Malásia: [4.210484, 101.975766],
  Malauí: [-13.254308, 34.301525],
  Maldivas: [3.202778, 73.22068],
  Mali: [17.570692, -3.996166],
  Malta: [35.937496, 14.375416],
  Marrocos: [31.791702, -7.09262],
  Maurício: [-20.348404, 57.552152],
  Mauritânia: [21.00789, -10.940835],
  México: [23.634501, -102.552784],
  Mianmar: [21.913965, 95.956223],
  Micronésia: [7.425554, 150.550812],
  Moçambique: [-18.665695, 35.529562],
  Moldávia: [47.411631, 28.369885],
  Mônaco: [43.750298, 7.412841],
  Mongólia: [46.862496, 103.846656],
  Montenegro: [42.708678, 19.37439],
  Namíbia: [-22.95764, 18.49041],
  Nauru: [-0.522778, 166.931503],
  Nepal: [28.394857, 84.124008],
  Nicarágua: [12.865416, -85.207229],
  Níger: [17.607789, 8.081666],
  Nigéria: [9.081999, 8.675277],
  Noruega: [60.472024, 8.468946],
  'Nova Zelândia': [-40.900557, 174.885971],
  Omã: [21.512583, 55.923255],
  Palau: [7.51498, 134.58252],
  Panamá: [8.537981, -80.782127],
  'Papua Nova Guiné': [-6.314993, 143.95555],
  Paquistão: [30.375321, 69.345116],
  Paraguai: [-23.442503, -58.443832],
  Peru: [-9.189967, -75.015152],
  Polônia: [51.919438, 19.145136],
  Portugal: [39.399872, -8.224454],
  Quênia: [-0.023559, 37.906193],
  Quirguistão: [41.20438, 74.766098],
  'Reino Unido': [55.378051, -3.435973],
  'República Centro Africana': [6.611111, 20.939444],
  'República da Coréia': [35.907757, 127.766922],
  'República Democrática do Congo': [-4.038333, 21.758664],
  'República Dominicana': [18.735693, -70.162651],
  'República Popular Democrática da Coréia': [40.339852, 127.510093],
  'República Tcheca': [49.817492, 15.472962],
  Romênia: [45.943161, 24.96676],
  Ruanda: [-1.940278, 29.873888],
  'Rússia (Federação Russa)': [61.52401, 105.318756],
  Samoa: [-13.759029, -172.104629],
  'San Marino': [43.94236, 12.457777],
  'Santa Lúcia': [13.909444, -60.978893],
  'São Cristóvão e Nevis': [17.357822, -62.782998],
  'São Tomé e Príncipe': [0.18636, 6.613081],
  'São Vicente e Granadinas': [12.984305, -61.287228],
  Seichelles: [-4.679574, 55.491977],
  Senegal: [14.497401, -14.452362],
  'Serra Leoa': [8.460555, -11.779889],
  Sérvia: [44.016521, 21.005859],
  Singapura: [1.352083, 103.819836],
  Síria: [34.802075, 38.996815],
  Somália: [5.152149, 46.199616],
  'Sri Lanka': [7.873054, 80.771797],
  Sudão: [12.862807, 30.217636],
  'Sudão do Sul': [6.876991, 31.306978],
  Suécia: [60.128161, 18.643501],
  Suíça: [46.818188, 8.227512],
  Suriname: [3.919305, -56.027783],
  Tadjiquistão: [38.861034, 71.276093],
  Tailândia: [15.870032, 100.992541],
  Tanzânia: [-6.369028, 34.888822],
  'Timor Leste': [-8.874217, 125.727539],
  Togo: [8.619543, 0.824782],
  Tonga: [-21.178986, -175.198242],
  'Trinidad e Tobago': [10.691803, -61.222503],
  Tunísia: [33.886917, 9.537499],
  Turcomenistão: [38.969719, 59.556278],
  Turquia: [38.963745, 35.243322],
  Tuvalu: [-7.109535, 177.64933],
  Ucrânia: [48.379433, 31.16558],
  Uganda: [1.373333, 32.290275],
  Uruguai: [-32.522779, -55.765835],
  Uzbequistão: [41.377491, 64.585262],
  Vanuatu: [-15.376706, 166.959158],
  Venezuela: [6.42375, -66.58973],
  Vietnã: [14.058324, 108.277199],
  Zâmbia: [-13.133897, 27.849332],
  Zimbábue: [-19.015438, 29.154857],
}

// Tiles vetoriais do OpenFreeMap: sem chave e sem limite de uso, ao contrário do CARTO
const BASE_MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/positron'

// O worker embutido no maplibre é montado com Function.toString(); o babel/terser do build de
// produção reescreve essas funções e o worker quebra ("a is not defined"), deixando o mapa sem fundo.
// Por isso usa a variante CSP, servida de public/ para o babel não tocar nela. O arquivo é
// gerado por scripts/copy-maplibre-worker.js no start e no build.
const BASE_MAP_WORKER_URL = `${process.env.PUBLIC_URL}/maplibre-gl-csp-worker.js`

export default { COUNTRY_COORDS, BASE_MAP_STYLE_URL, BASE_MAP_WORKER_URL }
